export default class GetSubtipoConvocatoriaByTipoAndId {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idTipoConvocatoria, id) {
    try {
      const result = await this.#repository.getSubtipoConvocatoriaByTipoAndId(idTipoConvocatoria, id)
      return result
    } catch (error) {
      console.error('Error al obtener el subtipo de convocatoria:', error)
      throw error
    }
  }
}
